import AuthenticationProvider from '../providers/AuthenticationProvider';

// Redux action to perform login
import bcrypt from 'bcryptjs';


export const login = (email, password) => {
    return async (dispatch) => {
        try {
            console.log("login auth");
            //const hashedPassword = "";

            const authenticationProvider = new AuthenticationProvider();
            const result = await authenticationProvider.checkCredentials(email, password);

            console.log("login2");
            console.log(result);

            // Dispatch actions based on authentication result
            if (result) {
                dispatch({ type: 'LOGIN_SUCCESS', payload: result });
            } else {
                dispatch({ type: 'LOGIN_FAILURE', payload: 'Authentication failed' });
            }
            return result;
        } catch (error) {
            console.error('Error during login:', error);
            dispatch({ type: 'LOGIN_FAILURE', payload: 'Internal error during login' });
            return null;
        }
    };
};

// Redux action to perform registration
export const register = (username, password, email, salt) => {
    return async (dispatch) => {
        try {
            console.log("register auth");
            // Generate a salt for password hashing
            const saltRounds = 10;
            const salt = await bcrypt.genSalt(saltRounds);

            // Hash the password using bcrypt
            const hashedPassword = await bcrypt.hash(password, salt);
            //const hashedPassword = "";

            const authenticationProvider = new AuthenticationProvider();
            console.log(hashedPassword);

            const referral = localStorage.getItem('referral');
            const result = await authenticationProvider.registerUser(username, hashedPassword, email, salt, referral);

            console.log(result);
            // Dispatch actions based on registration result
            if (result && result.success) {
                dispatch({ type: 'REGISTER_SUCCESS', payload: result });
            } else {
                dispatch({ type: 'REGISTER_FAILURE', payload: 'Registration failed' });
            }
            return result;
        } catch (error) {
            console.error('Error during registration:', error);
            dispatch({ type: 'REGISTER_FAILURE', payload: 'Internal error during registration' });
            return null;
        }
    };
};


export const loginFB = (accessToken, userID ) => {
    return async (dispatch) => {
        try {
            console.log("login FB");
            //const hashedPassword = "";
            const referral = localStorage.getItem('referral');
            const authenticationProvider = new AuthenticationProvider();
            const result = await authenticationProvider.loginFB(accessToken, userID, referral);

            console.log(result);

            // Dispatch actions based on authentication result
            if (result) {
                dispatch({ type: 'LOGIN_SUCCESS', payload: result });
            } else {
                dispatch({ type: 'LOGIN_FAILURE', payload: 'Authentication failed' });
            }
            return result;
        } catch (error) {
            console.error('Error during FB login:', error);
            dispatch({ type: 'LOGIN_FAILURE', payload: 'Internal error during login' });
            return null;
        }
    };
};


export const loginGoogle = (accessToken, googleId) => {
    return async (dispatch) => {
        try {
            console.log("login Google");
            //const hashedPassword = "";
            const referral = localStorage.getItem('referral');
            const authenticationProvider = new AuthenticationProvider();
            const result = await authenticationProvider.loginGoogle(accessToken, googleId, referral);

            console.log(result);

            // Dispatch actions based on authentication result
            if (result) {
                dispatch({ type: 'LOGIN_SUCCESS', payload: result });
            } else {
                dispatch({ type: 'LOGIN_FAILURE', payload: 'Authentication failed' });
            }
            return result;
        } catch (error) {
            console.error('Error during FB login:', error);
            dispatch({ type: 'LOGIN_FAILURE', payload: 'Internal error during login' });
            return null;
        }
    };
};
